import { FC, useMemo } from 'react';
import { Container } from '../../components/container/container';
import {
  AuthorStyled,
  ContainerAuthor,
  DetailWrap,
  DividerStyled,
  RelatedWrap,
  StyledBoxGrid,
  StyledGrid,
} from './style';
import { HeaderDetail } from '../../components/header-detail/header-detail';

import { BreadcrumbItem } from '../../components/breadcrumb/breadcrumb';
import { CardMedia, Title } from '@plataformaxvia/design-system';
import { NewsCardProps } from '../../apis/news-rss';
import { Grid, Typography } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import { buildDateFormatter } from '../../util/date';
import OptimizedImageComponent from '../../components/optimized-image';

export interface NewsDetailProps {
  title: string;
  category: string;
  content: string;
  thumbnail: string;
  author: string;
  createdAt?: Date | string | null;
  breadcrumb: BreadcrumbItem[];
  relatedNews?: NewsCardProps[];
  onClick: (slug: string) => void;
}

export const NewsDetail: FC<NewsDetailProps> = ({
  title,
  category,
  content,
  thumbnail,
  breadcrumb,
  relatedNews,
  author,
  createdAt,
  onClick,
}) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down(1200));

  const formattedDate = useMemo(() => {
    if (!createdAt) return null;
    const date =
      typeof createdAt === 'string' ? new Date(createdAt) : createdAt;

    const dateFormatter = buildDateFormatter({ locales: 'pt-BR' });

    return dateFormatter.format(date);
  }, [createdAt]);

  return (
    <>
      <HeaderDetail
        breadcrumbs={{ items: breadcrumb, lastItemEllipsis: true }}
      />
      <DetailWrap>
        <Container>
          <StyledGrid container spacing={3}>
            <Grid item xs={12} sm={isSmallScreen ? 12 : 6}>
              <Title title={title} info={category} />
              <StyledBoxGrid dangerouslySetInnerHTML={{ __html: content }} />
            </Grid>
            <Grid item xs={12} sm={isSmallScreen ? 12 : 6}>
              <OptimizedImageComponent
                src={thumbnail}
                alt="Imagem em miniatura da notícia (Thumbnail)"
                width="100%"
              />
              <DividerStyled />
              <ContainerAuthor>
                {!!formattedDate && (
                  <Typography
                    fontSize={'var(--font-subtitle-3)'}
                    lineHeight={'var(--line-height-subtitle-3)'}
                    letterSpacing={'var(--letter-spacing-subtitle-3)'}
                  >
                    {`Publicado em: ${formattedDate}`}
                  </Typography>
                )}
                {author && (
                  <AuthorStyled>
                    <PersonOutlineIcon />
                    {author}
                  </AuthorStyled>
                )}
              </ContainerAuthor>
            </Grid>
          </StyledGrid>
        </Container>
      </DetailWrap>
      <RelatedWrap>
        <Container>
          <Title title="Outras notícias" />
          <StyledGrid container spacing={3} sx={{ marginTop: '16px' }}>
            {relatedNews?.map((news) => (
              <Grid item xs={12} sm={isSmallScreen ? 12 : 6}>
                <CardMedia
                  title={news.title}
                  info={news.info}
                  imageUrl={news.imageUrl}
                  onClick={() => onClick(news.slug || '')}
                />
              </Grid>
            ))}
          </StyledGrid>
        </Container>
      </RelatedWrap>
    </>
  );
};
